import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Field, Input } from '../ui/Field';
import { useAuth } from '../../contexts/AuthContext';
import { USERNAME_MAX, USERNAME_MIN } from '../../utils/auth';
interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Overrides the live verdict, e.g. a server-side collision on submit. */
  error?: string | null;
}

/**
 * Availability is checked as the person types, and the verdict always states
 * WHICH rule applies rather than a bare "invalid".
 */
export function UsernameField({
  value,
  onChange,
  error
}: Props) {
  const {
    usernameVerdict
  } = useAuth();
  const verdict = value.trim() ? usernameVerdict(value) : null;
  return <div data-id="element-484" data-mp="8f418ithe37x">
      <Field label="Username" htmlFor="username" hint={`${USERNAME_MIN}–${USERNAME_MAX} characters. Letters, numbers, full stops and underscores. This is how people find and pay you.`} data-id="element-485" data-mp="8euagt0m3s16">
        <div className="relative" data-id="element-486" data-mp="2a7s58udy8uor">
          <span aria-hidden className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-body text-ink-muted" data-id="element-487" data-mp="mdeqnjf8l4li">
            @
          </span>
          <Input id="username" value={value} onChange={event => onChange(event.target.value.replace(/^@+/, ''))} autoComplete="username" spellCheck={false} className="pl-9" aria-invalid={verdict && !verdict.ok ? true : undefined} aria-describedby="username-verdict" data-id="element-488" data-mp="cnv8kfzclerp" />
        </div>
      </Field>

      <p id="username-verdict" aria-live="polite" className={`mt-2 flex items-start gap-2 text-body-sm ${!verdict ? 'text-ink-muted' : verdict.ok ? 'text-ok-700' : 'text-danger-700'}`} data-id="element-489" data-mp="ve34oe4mr4ye">
        {verdict?.ok && <CheckCircle2Icon aria-hidden className="mt-0.5 h-4 w-4 shrink-0" data-id="element-490" data-mp="3b5qyw1s9ejdi" />}
        {verdict && !verdict.ok && <XCircleIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0" data-id="element-491" data-mp="235ikps80gc4u" />}
        {error ?? verdict?.message ?? 'Choose a username to check whether it is available.'}
      </p>
    </div>;
}